import { useEffect, useState } from "react";
import {
  getWindowSecureSupport,
  requestWindowSecure,
  type WindowSecureSupport,
} from "../utils/window-secure";

/**
 * The host bridge is installed by a synchronous script ahead of the bundle and
 * never changes afterwards, so reading it once into state is enough.
 */
export const useWindowSecureSupport = (): WindowSecureSupport => {
  const [support] = useState(getWindowSecureSupport);
  return support;
};

/**
 * Keep secure-window mode on while `enabled` is true and release it when the
 * component unmounts or `enabled` flips back to false.
 */
export const useWindowSecure = (enabled: boolean): void => {
  useEffect(() => {
    if (!enabled) return;
    return requestWindowSecure();
  }, [enabled]);
};
